module.exports = __webpack_public_path__ + "static/media/plus.acbcd9cf.svg";